function DevBlog() {
  return (
    <div className="flex flex-col items-center justify-center">
      <h1 className="text-5xl font-bold text-center">Dev Blog</h1>
      <p className="text-xl text-center">Coming soon...</p>
    </div>
  );
}
// meow
export default DevBlog;
